import script from "./chemical-knowledge.vue?vue&type=script&lang=js&setup=true"
export * from "./chemical-knowledge.vue?vue&type=script&lang=js&setup=true"

import "./chemical-knowledge.vue?vue&type=style&index=0&id=57febc96&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57febc96"]])

export default __exports__